import React, { useState } from "react";
import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import ErrorPopup from "./ErrorPopup";
import Loader from "./Loader";
import { textMapping } from "../utils/helper";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB5pcUfpjn7n0CF3CCB9sKhvho92Q8vEe4",
  authDomain: "bjp-mem.firebaseapp.com",
  projectId: "bjp-mem",
  storageBucket: "bjp-mem-staging",
  messagingSenderId: "24775571254",
  appId: "1:24775571254:web:22eab6f8238f3cd1846597",
  measurementId: "G-2SJTJ43SRQ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

const errorStyle = {
  color: "red",
};

const ImageUploadPopup = ({ ImagePopupClose, UploadHanlde }) => {
  const [imageURL, setImageURL] = useState(null);
  const [showImage, setShowImage] = useState(false);
  const [errorpopup, setErrorpopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errormsg, setErrormsg] = useState("");
  const [message, setMessage] = useState("");
  const allowFiletype = ["image/heic", "image/png", "image/jpeg", "image/jpg"];

  const uploadHandler = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    if (file) {
      if (allowFiletype.includes(file.type)) {
        setErrormsg("");
        let name = file.name.split(".");
        let ext = name[name.length - 1];
        var sessionid = Date.now();
        const random = Math.floor(100000 + Math.random() * 900000);
        const fileName = `${random}_${sessionid}.${ext}`;
        const imageRef = ref(storage, `images/${fileName}`);

        try {
          // Compress image
          const compressedFile = await compressImage(file);

          // Upload compressed file
          await uploadBytes(imageRef, compressedFile);

          // Get download URL
          const url = await getDownloadURL(imageRef);

          // if (url) {
          //   // After successful upload, call the moderation API
          //   const myHeaders = new Headers();
          //   myHeaders.append("Content-Type", "application/json");

          //   const raw = JSON.stringify({
          //     imageUrl: url,
          //   });

          //   const requestOptions = {
          //     method: "POST",
          //     headers: myHeaders,
          //     body: raw,
          //     redirect: "follow",
          //   };

          //   fetch(
          //     "https://campaign-api.narendramodi.in/sadasyata_moderation_2024",
          //     requestOptions
          //   )
          //     .then((response) => response.text())
          //     .then((result) => {
          //       const parsedResult = JSON.parse(result);
          //       if (parsedResult.data && parsedResult.data.length > 0) {
          //         setErrorpopup(true);
          //         setMessage(
          //           "Your photo violates our content guidelines. Please upload an appropriate image."
          //         );
          //         // Clear the file input
          //         e.target.value = null;
          //       } else if (parsedResult.data && parsedResult.data.length == 0) {
          //         setImageURL(url);
          //         setShowImage(true);
          //       } else {
          //         console.log("Image moderation passed");
          //       }
          //     })
          //     .catch((error) => {
          //       console.error(error);
          //       setErrorpopup(true);
          //       setMessage("Error in image moderation. Please try again.");
          //     });

          //   console.log("Image URL:", url);
          // } else {
          //   setErrorpopup(true);
          //   setMessage("Failed to get download URL. Please try again.");
          // }
          // setShowImage(true);
          setLoading(false);
          setImageURL(url);
          setShowImage(true);
        } catch (error) {
          setErrorpopup(true);
          setMessage(error);
          setLoading(false);
        }
      } else {
        setErrormsg("Please select a valid image file (JPEG, PNG, HEIC).");
        setLoading(false);
      }
    }
  };

  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const scaleFactor = 0.7; // Adjust this value to change compression level
          canvas.width = img.width * scaleFactor;
          canvas.height = img.height * scaleFactor;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(
            (blob) => {
              resolve(new File([blob], file.name, { type: file.type }));
            },
            file.type,
            0.7 // Adjust this value to change compression quality
          );
        };
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const popupclose = () => {
    setErrorpopup(false);
  };

  return (
    <>
      {loading && <Loader />}
      <div className="popup_bg">
        <div className="imgetype_bg">
          <div className="selcttype_img">
            {!showImage && (
              <div>
                <img
                  src="/assets/images/cloud.png"
                  className="upload_icons"
                  alt="Upload Icon"
                />
                <h4>{textMapping("Select")}</h4>

                <ul className="uploadtype_list">
                  <li>
                    <div className="gallery_uplpad">
                      <input
                        type="file"
                        // accept="image/png,image/jpeg,image/jpg, .heic"
                        accept=".png, .jpeg, .jpg, .heic"
                        onChange={uploadHandler}
                      />
                      <h6>{textMapping("Gallery")}</h6>
                    </div>
                  </li>
                </ul>
                <p>Support format: JPEG, JPG, PNG, HEIC</p>
              </div>
            )}

            {/* After upload the image show this div */}
            {showImage && (
              <div>
                <img
                  src={imageURL ? imageURL : "/assets/images/userdefault.jpg"}
                  className="upload_img_preview"
                  alt=""
                />
                <button className="cancel_btn" onClick={ImagePopupClose}>
                  {textMapping("Cancel")}
                </button>
              </div>
            )}
            {errormsg && <p style={errorStyle}>{errormsg} </p>}
          </div>

          {/* Hide this button after uploading the image */}
          {!showImage && (
            <button className="cancel_btn" onClick={ImagePopupClose}>
              {textMapping("Cancel")}
            </button>
          )}

          {/* After upload the image show this button */}
          {showImage && (
            <button
              className="uploadimg_btn"
              onClick={() => UploadHanlde(imageURL)}
            >
              {textMapping("Upload")}
              {/* <img src="/assets/images/gradloader.png" className="grad_loader" alt="" /> */}
            </button>
          )}
        </div>
      </div>
      {errorpopup && <ErrorPopup message={message} popupclose={popupclose} />}
    </>
  );
};

export default ImageUploadPopup;
